const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 80,
  },
  {
    prop: "COCode",
    label: "单据号",
    columnwidth: 180,
  },
  {
    prop: "CODate",
    label: "寄售日期",
    columnwidth: 120,
  },
  {
    prop: "ReturnFlagName",
    label: "寄售方向",
    columnwidth: 100,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 120,
  },
  {
    prop: "HospitalName",
    label: "寄售公司",
    columnwidth: 150,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 150,
  },
  {
    prop: "CreatorName",
    label: "上报方",
    columnwidth: 210,
  },
  {
    prop: "CreateTime",
    label: "上报时间",
    columnwidth: 180,
  },
  {
    prop: "VerifierName",
    label: "审核人",
    columnwidth: 210,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 180,
  },
]
export default headerData
